import React from 'react';
import {
    LogViewer,
} from '@backstage/core-components';

import { useContainerLog } from '../../hooks/useContainerLog';

export interface ContainerLogViewProps {
    itemRef: string;
    pod: string;
    container: string;
}

export function ContainerLogView({
    itemRef,
    pod,
    container,
}: ContainerLogViewProps) {
    const [{ value }] = useContainerLog({ itemRef, pod, container });

    return (
        <>
            <div style={{ height: 240 }}>
                <LogViewer text={value?.content || ''} />
            </div>
        </>
    );
}
